import { ApiEndpointTags } from '../imago-mp.types';

export type DeleteAddonInput = {
    id: string;
    subscriptionId: string;
};

export const deleteAddonMutation = {
    query: ({ id }: DeleteAddonInput) => ({
        url: `/mp/1/addons/${id}`,
        method: 'delete',
    }),
    invalidatesTags: (_result: void, _error: unknown, arg: DeleteAddonInput) => [
        { type: ApiEndpointTags.Subscription, id: arg.subscriptionId },
    ],
};
